import { render, staticRenderFns } from "./PotentialPartnersList.vue?vue&type=template&id=7db23418&scoped=true"
import script from "./PotentialPartnersList.vue?vue&type=script&lang=js"
export * from "./PotentialPartnersList.vue?vue&type=script&lang=js"
import style0 from "./PotentialPartnersList.vue?vue&type=style&index=0&id=7db23418&prod&lang=scss&scoped=true"
import style1 from "./PotentialPartnersList.vue?vue&type=style&index=1&id=7db23418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db23418",
  null
  
)

export default component.exports